<template>
  <div class="back-button__container" @click="onBack">
    <slot name="prefixIcon">
      <i class="el-icon-arrow-left"></i>
    </slot>
    <slot>
      <span>{{ system.backPreviousPageTxt }}</span>
    </slot>
    <slot name="suffixIcon"></slot>
  </div>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  name: 'BackButton',

  props: {
    customBack: {
      type: Boolean,
      default: false
    }
  },

  emits: ['on-back'],

  data() {
    return {

    }
  },

  computed: {
    ...mapGetters(["currentLang"]),
    navbar() {
      return this.currentLang.config.navbar;
    },
    system() {
      return this.currentLang.config.system;
    }
  },

  created() {

  },

  methods: {
    onBack() {
      if (this.customBack) {
        this.$emit('on-back')
      }
      else {
        this.$router.go(-1);
      }
    }
  }
}
</script>


<style scoped>
* {
  box-sizing: border-box;
}

.back-button__container {
  display: inline-block;
  padding: 6px 12px;
  /* background: #00335a; */
  border-radius: 5px;
  display: flex;
  align-items: center;
  color: #fff;
  color: var(--main-color-blue);
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  vertical-align: middle;
}

.el-icon-arrow-left {
  margin-right: 2px;
  font-size: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/BackButton.vue